import React from "react";
import { priceList } from "../mock";
import { ArrowRight } from "lucide-react";

const PriceList = ({ onEnquire }) => (
  <section id="price-list-section" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundImage: `url(${priceList.bg})`, backgroundSize: "cover" }}>
    <div className="absolute inset-0 bg-[#f8f2e8]/90" />
    <img src={priceList.flower} alt="" className="ornament right-0 top-16 w-40 opacity-70" />
    <div className="relative max-w-[1220px] mx-auto px-5 lg:px-8">
      <div className="section-head">
        <p className="eyebrow">Price List</p>
        <div className="divider-leaf my-3" />
        <h2 className="h-title">Premium Quality at a Price You Deserve!</h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {priceList.items.map((p) => (
          <div key={p.type} className="relative bg-white/85 border border-[#c26a4a]/30 rounded-[20px] p-8 text-center card-lift overflow-hidden">
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#c26a4a] via-[#d68767] to-[#c26a4a]" />
            <p className="font-display-e text-[13px] tracking-[.24em] text-[#c26a4a]">RESIDENCE</p>
            <h3 className="h-title text-[30px] md:text-[34px] mt-2">{p.type}</h3>
            <div className="divider-leaf my-4" />
            <p className="font-serif-e text-[18px] text-[#4a4a44]">{p.area}</p>
            <p className="font-serif-e text-[26px] md:text-[30px] font-semibold text-[#2a3d5c] mt-2">{p.price}</p>
            <button onClick={onEnquire} className="btn-gold mt-6 w-full justify-center">
              INTERESTED <ArrowRight size={14} />
            </button>
          </div>
        ))}
      </div>
      <p className="text-center mt-8 font-serif-e text-[18px] italic text-[#2a3d5c]">{priceList.note}</p>
    </div>
  </section>
);

export default PriceList;
